export default __webpack_public_path__ + "freelancer-toolkit-logo.58829b98.webp";